import { formatUserFacingDbError } from '@ubus/shared';

/** Admin UI: map DB/RPC errors using current i18n language. */
export function formatAdminDbError(
  err: unknown,
  lang?: string,
  action: 'delete' | 'update' | 'save' = 'delete',
): string {
  const locale = lang?.startsWith('en') ? 'en' : 'zh-CN';
  return formatUserFacingDbError(err, { locale, action });
}
